import React from 'react';
import AskQuestion from '../containers/AskQuestion';

export default function CasteDotazy() {
  return (
    <div>
      <AskQuestion />
    </div>
  );
}
